import JobRequest from '@assets/widgets/job_request.png';
import JobDescription from '@assets/widgets/job_description.png';
import Dashboard from '@assets/widgets/dashboard.png';
import CandidatePipeline from '@assets/widgets/candidate_pipeline.png';
import Interview_Schedule from '@assets/widgets/interview_schedule.png';
import LeaveBalance from '@assets/widgets/leave_balance.png';
import ShortlistedResumes from '@assets/widgets/shortlisted_resumes.png';
import TipsOfTheDay from '@assets/widgets/tips_of_the_day.png';

export const WIDGET_PREVIEW_IMAGES = {
    JOB_REQUEST: JobRequest,
    JOB_DESCRIPTION: JobDescription,
    DASHBOARD: Dashboard,
    CANDIDATE_PIPELINE: CandidatePipeline,
    INTERVIEW_SCHEDULE: Interview_Schedule,
    LEAVE_BALANCE: LeaveBalance,
    SHORTLISTED_RESUMES: ShortlistedResumes,
    TIPS_OF_THE_DAY: TipsOfTheDay,
};
